<template>
  <footer class="flex flex-none z-20 relative items-center bg-white dark:bg-darkblue-900 justify-end pl-20 lg:pl-10 pr-4 lg:pr-10 border-t border-primary-50 dark:border-darkblue-600 pb-0 select-none">
    <base-button
      v-if="hasActions"
      class="mobile-trigger"
      icon="chevronup"
      :text="resolvedButtonLabel"
      mode="secondary"
      :icon-class="['transition-transform duration-200', { 'rotate-180': mobileOpen }]"
      :aria-expanded="mobileOpen.toString()"
      aria-haspopup="true"
      :aria-label="resolvedAriaLabel"
      @click.stop="mobileOpen = !mobileOpen"
    />

    <div
      class="content-actions"
      :class="{ 'is-open': mobileOpen }"
      role="toolbar"
    >
      <slot name="actions"/>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'base-footer',
  props: {
    buttonLabel: {
      type: String,
    },
  },
  data () {
    return {
      mobileOpen: false,
    }
  },
  computed: {
    hasActions () {
      return !!this.$slots.actions
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    resolvedButtonLabel () {
      if (this.buttonLabel) return this.buttonLabel
      return this.isLower1024
        ? this.$t('components.baseFooter.actions_general')
        : this.$t('components.baseFooter.actions')
    },
    resolvedAriaLabel () {
      if (this.mobileOpen) {
        return this.isLower1024
          ? this.$t('components.baseFooter.close_general')
          : this.$t('components.baseFooter.close')
      }
      return this.isLower1024
        ? this.$t('components.baseFooter.open_general')
        : this.$t('components.baseFooter.open')
    },
  },
  mounted () {
    document.addEventListener('click', this.onClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onClickOutside)
  },
  methods: {
    onClickOutside (e) {
      if (this.mobileOpen && !this.$el.contains(e.target)) {
        this.mobileOpen = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-trigger {
  display: none;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  @media (max-width: 639px) { display: block; }
}

.content-actions {
  display: flex;
  align-items: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  gap: 0.5rem;

  > * { flex-shrink: 0; }

  @media (max-width: 639px) {
    display: none;
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    padding: 0.5rem;
    background-color: #fff;
    border-top: 1px solid theme('colors.primary.50');
    box-shadow: 0 -4px 12px rgba(0,0,0,0.12);
    z-index: 30;

    &.is-open { display: flex; }

    .dark & {
      background-color: theme('colors.darkblue.900');
      border-top-color: theme('colors.darkblue.600');
    }

    > * { flex-shrink: 1; max-width: 100%; }
  }
}
</style>
